import { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminHeader, Card, StatusBadge, Empty } from "@/components/admin/ui";
import { formatINR } from "@/lib/format";
import { CreditCard, CheckCircle2, AlertCircle } from "lucide-react";

export default function AdminPayments() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/payments").then(({ data }) => setData(data)); }, []);
  if (!data) return null;

  return (
    <div>
      <AdminHeader title="Payments" subtitle="Transactions & gateway status" />
      <Card className="p-5 mb-6">
        <div className="flex items-center gap-3">
          <span className="h-11 w-11 rounded-lg bg-slate-100 grid place-items-center"><CreditCard className="h-6 w-6 text-slate-600" /></span>
          <div className="flex-1">
            <p className="font-semibold text-slate-900 capitalize">{data.provider.provider}</p>
            <p className="text-sm text-slate-500">Mode: {data.provider.mode}</p>
          </div>
          {data.provider.configured
            ? <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-600"><CheckCircle2 className="h-4 w-4" /> Connected</span>
            : <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-amber-600"><AlertCircle className="h-4 w-4" /> Not Configured</span>}
        </div>
        {!data.provider.configured && <p className="text-xs text-slate-500 mt-3 p-3 bg-amber-50 border border-amber-100 rounded-lg">Add <code className="font-mono">RAZORPAY_KEY_ID</code>, <code className="font-mono">RAZORPAY_KEY_SECRET</code> and <code className="font-mono">RAZORPAY_WEBHOOK_SECRET</code> to the backend environment to enable live payments. The secret is never exposed to the frontend.</p>}
      </Card>

      <Card className="overflow-hidden">
        <table className="w-full text-sm text-left">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase"><tr><th className="p-3">Order</th><th className="p-3">Amount</th><th className="p-3">Method</th><th className="p-3">Provider</th><th className="p-3">Status</th><th className="p-3">Date</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {data.payments.map((p) => (
              <tr key={p.id} className="hover:bg-slate-50">
                <td className="p-3 font-mono">{p.orderNumber}</td>
                <td className="p-3 font-mono">{formatINR(p.amount)}</td>
                <td className="p-3">{p.method}</td>
                <td className="p-3 capitalize">{p.provider}</td>
                <td className="p-3"><StatusBadge status={p.status} /></td>
                <td className="p-3 text-xs text-slate-500">{new Date(p.createdAt).toLocaleDateString("en-IN")}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {data.payments.length === 0 && <Empty text="No payments yet" />}
      </Card>
    </div>
  );
}
